import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShoppingBagFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.08 3.552H10.504V2.392C10.504 1.664 9.704 1 8.936 1H7.096C6.336 1 5.504 1.664 5.504 2.392V3.552H2.92C2.408 3.552 2 3.944 2 4.432V14.52C2 15.008 2.416 15.4 2.92 15.4H13.072C13.584 15.4 13.992 15.008 13.992 14.52V4.432C13.992 3.944 13.576 3.552 13.072 3.552H13.08ZM6.632 5.592C6.632 5.592 6.584 5.968 6.088 5.968C5.536 5.968 5.536 5.528 5.536 5.528V4.976H6.632V5.592ZM6.632 2.712C6.632 2.472 6.84 2.272 7.096 2.272H8.936C9.192 2.272 9.4 2.472 9.4 2.712V3.552H6.64V2.712H6.632ZM10.496 5.592C10.496 5.592 10.448 5.968 9.952 5.968C9.4 5.968 9.4 5.528 9.4 5.528V4.976H10.496V5.592Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgShoppingBagFilled)
const IconSvgShoppingBagFilled = createIcon(ForwardRef, 'SvgShoppingBagFilled')
export default IconSvgShoppingBagFilled
